import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Metric/services/constants";

export const clearKeywordScanStats = createAction(`${moduleSlug}/CLEAR_KEYWORD_SCAN_STATS`);

export const getKeywordScanStats = createAction(`${moduleSlug}/GET_KEYWORD_SCAN_STATS`);
export const getKeywordScanStatsSuccess = createAction(`${moduleSlug}/GET_KEYWORD_SCAN_STATS/SUCCESS`);
export const getKeywordScanStatsError = createAction(`${moduleSlug}/GET_KEYWORD_SCAN_STATS/ERROR`);
